import {createStyles} from '@material-ui/core/styles';
import type {Theme} from '@material-ui/core/styles';
import background from 'assets/img/bg-sidebar.svg';
import * as colors from 'assets/theme/colors';

const sidebarWidth = 380;
const viewPortUnits = '26.389vw'; // 380/1440*100

export default createStyles((theme: Theme) => ({
    root: {
        width: `${viewPortUnits}`,
        minWidth: sidebarWidth,
        flexShrink: 0,
        background: `${colors.primary.A00} !important`,
    },
    paper: {
        width: `${viewPortUnits}`,
        minWidth: sidebarWidth,
        backgroundImage: `url(${background})`,
        backgroundSize: 'cover',
        padding: theme.spacing(16, 12), //'80px 48px',
    },
    loggedIn: {
        backgroundImage: undefined,
        backgroundColor: colors.primary.A00,
        width: `${viewPortUnits}`,
        minWidth: sidebarWidth,
        backgroundSize: 'cover',
        padding: theme.spacing(16, 12), //'80px 48px',
    },
    docked: {
        color: colors.neutrals.A10,
        borderRight: 'none',
    },
    text: {
        color: theme.palette.primary.contrastText,
    },
    menu: {
        color: colors.neutrals.A10,
        backgroundColor: colors.primary.A00,
    },
}));
